import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner, Form, Button } from "react-bootstrap";
import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const MasterIkanSatuan = () => {
  const columns = [
    {
      name: 'ID Satuan',
      selector: row => row.idSatuan,
      sortable: true
    },
    {
      name: 'Kode Kelas',
      selector: row => row.kdKelas,
      sortable: true
    },
    {
      name: 'Kategori Komoditi',
      selector: row => row.kategoriCmdts,
      sortable: true
    },
    {
      name: 'Kode Satuan',
      selector: row => row.kodeSatuan,
      sortable: true
    },
    {
      name: 'Satuan',
      selector: row => row.satuan,
      sortable: true
    }
  ];

  const masterService = useMemo(() => new MasterService(), []);

  const [originalData, setOriginalData] = useState([]); // Data lengkap
  const [filteredData, setFilteredData] = useState([]); // Data hasil filter
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const getAllData = useCallback(async () => {
    setLoading(true);
    try {
      // Ambil data sebanyak mungkin (disarankan dibatasi jika besar)
      const response = await masterService.listIkanSatuan(null, 0, 10000); 
      setOriginalData(response.data.data);
      setFilteredData(response.data.data);
    } catch (error) {
      console.log(error);
      setOriginalData([]);
      setFilteredData([]);
    }
    setLoading(false);
  }, [masterService]);

  useEffect(() => {
    getAllData();
  }, [getAllData]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = originalData.filter(item =>
      (item.idSatuan || "").toString().toLowerCase().includes(value) ||
      (item.kdKelas || "").toLowerCase().includes(value) ||
      (item.kategoriCmdts || "").toLowerCase().includes(value) ||
      (item.kodeSatuan || "").toLowerCase().includes(value) ||
      (item.satuan || "").toLowerCase().includes(value)
    );

    setFilteredData(filtered);
  };

  return (
    <>
      <Row>
        <Col sm="12">
            <Card>
                <Card.Header className="d-flex justify-content-between">
                    <div className="header-title">
                        <h4 className="card-title">Pencarian Data</h4>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Form>
                        <Row className="align-items-end">
                            <Col sm="3">
                                <Form.Group>
                                    <Form.Control
                                        type="text"
                                        placeholder="Cari berdasarkan ID, Kode, atau Satuan"
                                        value={searchTerm}
                                        onChange={handleSearch}
                                        style={{ maxWidth: "300px" }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">Daftar Master Ikan Satuan</h4>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive border-bottom my-3">
                {loading ? (
                  <Spinner animation="border" />
                ) : (
                  <DataTable
                    customStyles={{
                      headCells: {
                        style: {
                          backgroundColor: '#00acee',
                          color: 'white',
                        }
                      }
                    }}
                    columns={columns}
                    data={filteredData}
                    highlightOnHover
                    pagination
                  />
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default MasterIkanSatuan;
